import "./style.scss";

import { useTracker } from "contexts/tracker";
import type { CSSProperties } from "react";
import { useEffect } from "react";

const AuthPage = (props: {
    userAuthenticated?: boolean;
    direction?: "horizontal" | "vertical";
    style?: CSSProperties;
    children?: React.ReactNode;
    pageName?: string;
}) => {
    const tracker = useTracker();

    useEffect(() => {
        if (props.userAuthenticated === false) {
            window.location.href = "/login";
        }
    }, [props]);

    useEffect(() => {
        if (props.pageName && tracker) {
            tracker.trackEvent("Page visit", {
                name: props.pageName,
            });
        }
    }, [props.pageName, tracker]);

    return (
        <>
            <div className={`auth-page-container ${props.direction || ""}`} style={props.style}>
                {props.children}
            </div>
        </>
    );
};

export default AuthPage;
